import {
  IconStatusFailedFill,
  IconStatusPassedFill,
  IconStatusQueuedFill,
} from '@saucelabs/ds-icons';
import classnames from 'classnames';
import React from 'react';

import { DiffStatus } from '../../graphql/__generated__/graphql';
import { FilterBarState, FilterItem, FilterState } from './types';

export const VISUAL_SLICE_NAME = 'visual/buildDetailsFilterBar';

const BASE_ICON_CLASS = 'w-2 h-2 mr-1 fill-current';

export const STATUSES: FilterItem<DiffStatus>[] = [
  {
    key: DiffStatus.Approved,
    label: 'Accepted',
    prefixIcon: <IconStatusPassedFill className={classnames(BASE_ICON_CLASS, 'text-green-600')} />,
  },
  {
    key: DiffStatus.Equal,
    label: 'No Changes',
    prefixIcon: <IconStatusPassedFill className={classnames(BASE_ICON_CLASS, 'text-green-600')} />,
  },
  {
    key: DiffStatus.Unapproved,
    label: 'For Review',
    prefixIcon: <IconStatusQueuedFill className={classnames(BASE_ICON_CLASS, 'text-orange-600')} />,
  },
  {
    key: DiffStatus.Rejected,
    label: 'Rejected',
    prefixIcon: <IconStatusFailedFill className={classnames(BASE_ICON_CLASS, 'text-red-900')} />,
  },
];

export enum DetailsGroupBy {
  SuiteName = 'SuiteName',
  TestName = 'TestName',
  Device = 'Device',
  Browser = 'Browser',
  OS = 'OS',
  StorybookGroup = 'StorybookGroup',
  StorybookName = 'StorybookName'
}

export const GROUP_BY: FilterItem<DetailsGroupBy>[] = [
  {
    key: DetailsGroupBy.SuiteName,
    label: 'Suite Name',
  },
  {
    key: DetailsGroupBy.TestName,
    label: 'Test Name',
  },
  {
    key: DetailsGroupBy.Device,
    label: 'Device',
  },
  {
    key: DetailsGroupBy.Browser,
    label: 'Browser',
  },
  {
    key: DetailsGroupBy.OS,
    label: 'OS',
  },
  {
    key: DetailsGroupBy.StorybookGroup,
    label: 'Storybook (Depth 1)',
  },
  {
    key: DetailsGroupBy.StorybookName,
    label: 'Storybook (Depth 2)',
  },
];

const makeFilter = <T extends unknown = string>(items?: FilterItem<T>[]): FilterState<T> => ({
  value: [],
  items: items ?? [],
  searchValue: null,
  loading: false,
});

export const DEFAULT_PROJECT_KEY = 'default';

export const getInitialState = (): FilterBarState => ({
  init: 'idle',
  project: DEFAULT_PROJECT_KEY,
  userUpdated: false,
  search: {
    searchValue: '',
    inputValue: '',
  },
  os: makeFilter(),
  browser: makeFilter(),
  device: makeFilter(),
  status: makeFilter(STATUSES),
  groupBy: {
    ...makeFilter(GROUP_BY),
    value: [DetailsGroupBy.SuiteName, DetailsGroupBy.TestName],
  },
});
